import script from "./PdfCardTile.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfCardTile.vue?vue&type=script&setup=true&lang=js"

import "./PdfCardTile.vue?vue&type=style&index=0&id=699d7dcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-699d7dcc"]])

export default __exports__